"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.arrayOrEmpty = exports.deserialize = exports.serialize = exports.groupBy = exports.map = exports.toObj2 = exports.toObj = void 0;
var toConsumableArray_1 = __importDefault(require("@babel/runtime/helpers/esm/toConsumableArray"));
var toObj = function toObj(idFn) {
    return function (items) {
        return (items || []).reduce(function (o, x) {
            var _Object$assign;
            return Object.assign(o, (_Object$assign = {}, _Object$assign[idFn(x)] = x, _Object$assign));
        }, {});
    };
};
exports.toObj = toObj;
var toObj2 = function toObj2(fk) {
    return function (fv) {
        return function (items) {
            return (items || []).reduce(function (o, x) {
                var _Object$assign2;
                return Object.assign(o, (_Object$assign2 = {}, _Object$assign2[fk(x)] = fv(x), _Object$assign2));
            }, {});
        };
    };
};
exports.toObj2 = toObj2;
var map = function map(f) {
    return function (items) {
        return (items || []).map(f);
    };
};
exports.map = map;
var groupBy = function groupBy(selector) {
    return function (f) {
        return function (items) {
            return (items || []).reduce(function (o, x) {
                var _o$k, _Object$assign3;
                var k = selector(x);
                return Object.assign({}, o, (_Object$assign3 = {}, _Object$assign3[k] = [].concat(toConsumableArray_1.default((_o$k = o[k]) !== null && _o$k !== void 0 ? _o$k : []), [f(x)]), _Object$assign3));
            }, {});
        };
    };
};
exports.groupBy = groupBy;
var serialize = function serialize(x) {
    return Array.isArray(x) ? JSON.stringify(x) : null;
};
exports.serialize = serialize;
var deserialize = function deserialize(x) {
    return JSON.parse(x || null) || [];
};
exports.deserialize = deserialize;
var arrayOrEmpty = function arrayOrEmpty(x) {
    return Array.isArray(x) ? x : [];
};
exports.arrayOrEmpty = arrayOrEmpty;
